import { Placeholder } from 'reactstrap'

const SkeletonAccordion = ({ count = 5 }) => {
    return (
        <>
            {[...Array(count)].map((_, index) => (
                <div className="acitivity-item py-3 d-flex" key={index}>
                    <div className="flex-shrink-0 avatar-xs acitivity-avatar">
                        {/* icon placeholder */}
                        <Placeholder
                            tag="div"
                            className="avatar-title rounded-circle"
                            animation="glow"
                            style={{ width: '32px', height: '32px', backgroundColor: '#e9ecef' }}
                        >
                            <Placeholder xs={12} style={{ borderRadius: '50%' }} />
                        </Placeholder>
                    </div>
                    <div className="flex-grow-1 ms-3">
                        <div className="d-flex align-items-center justify-content-between mb-4">
                            {/* header placeholder (title/date) */}
                            <div style={{ width: '100%' }}>
                                <Placeholder animation="glow">
                                    <Placeholder xs={6} className="mb-1 d-block" />
                                    <Placeholder xs={4} size="sm" />
                                </Placeholder>
                            </div>
                        </div>
                        {/* description placeholder */}
                        <Placeholder animation="glow">
                            <Placeholder xs={12} className="mb-2" />
                            <Placeholder xs={8} />
                        </Placeholder>
                    </div>
                </div>
            ))}
        </>
    )
}

export default SkeletonAccordion
